<template>
  <form id="top_of_form" class="form one grg40 needs-validation" @submit="submitForm" method="post">
    <div class="input-group" v-if="typeof validationErrors !== 'undefined'">
      <ul class="invalid-feedback">
        <p><strong>There were some errors in your submission:</strong></p>
        <li v-for="(value,key,index) in validationErrors">
          {{ value[0] }}
        </li>
      </ul>
    </div>
    <div class="input-group one grg20">
      <h4 class="bold pc1">Fundraiser Details</h4>
      <div class="input-group one grg10">
        <label>Your email address</label>
        <div class="col2-span form-group grg10">
          <input class="form-control" v-model="person.email" id="email" :placeholder="person.email">
        </div>
      </div>
      <div class="input-group one grg10">
        <label>First Name</label>
        <div class="col2-span form-group grg10">
          <input class="form-control" v-model="person.first_name" id="first_name" :placeholder="person.first_name">
          <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.first_name"></lara-error>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import TextInput from '../Donation/TextInput';
import LaraError from "../general/LaraError";
import Loading from "../general/Loading";
export default {
  name: "FundraiserRegister",
  props: {
    person: {
      type: Array,
      required: true
    },
    events: {
      type: Array,
      required: true
    }
  },
  components: {
    TextInput,
    LaraError,
    Loading
  },
  data: () => ({
    loading: true,
    register: {
      email: ''
    },
    validationErrors: undefined,
  }),
  methods: {
    submitForm() {
      return true;
    }
  }
}
</script>

<style scoped>

</style>
